import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export interface IHandleGet {
  orderTable?: "asc" | "desc" | undefined;
  id_contrato?: string | undefined;
  currentPage?: number | undefined;
  itensPerPage?: number | undefined;
  nameSearch?: string | undefined;
  codProposta?: string | undefined;

  codeOperadora?: string | undefined;
  codeCorretor?: string | undefined;
  codeAdministradora?: string | undefined;

  startDateSignature?: string | undefined;
  endDateSignature?: string | undefined;

  startDueDate?: string | undefined;
  endDueDate?: string | undefined;

  startDateEmission?: string | undefined;
  endDateEmission?: string | undefined;

  startDateReceipt?: string | undefined;
  endDateReceipt?: string | undefined;
  installmentNumber?: string | undefined;

  installmentReceipt?: "TRUE" | "FALSE" | "ALL" | undefined;

  isInstallmentBroker?: "TRUE" | "FALSE" | "ALL" | undefined;
  isInstallmentSupervisor?: "TRUE" | "FALSE" | "ALL" | undefined;
  isInstallmentManager?: "TRUE" | "FALSE" | "ALL" | undefined;

  isVitalicioCorretora?: "TRUE" | "FALSE" | "ALL" | undefined;
  isVitalicioCorretor?: "TRUE" | "FALSE" | "ALL" | undefined;
  isVitalicioSupervisor?: "TRUE" | "FALSE" | "ALL" | undefined;
  isVitalicioGerente?: "TRUE" | "FALSE" | "ALL" | undefined;
  isDeleted?: "TRUE" | "FALSE" | "ALL" | boolean | undefined;

  installmentNumberOperator?: "EQUAL" | "GREATER" | "LESS" | "ALL" | undefined;

  client?: {
    nameOrRazao?: string | undefined;
    cpfCnpj?: string | undefined;
  };
}

export const useHttpTableBordero = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { setListBordero } = useContextContrato();

  const {
    setQtd_registros,
    setLoadingTable,
    itensPerPage,
    currentPage,
    nameSearch,
  } = useConfigPageContext();

  const handleGet = async (body: IHandleGet) => {
    setLoadingTable(true);

    api
      .post("/getBordero", {
        ...body,
        orderByParcelas: body.orderTable,
        page: currentPage,
        limit: itensPerPage,
        filter: nameSearch,
      })
      .then((res) => {
        setListBordero(res.data);
        setQtd_registros(res.data.count);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
